import { v4 as uuidv4 } from 'uuid';
import { CHOICE_LIMIT_ZERO } from '../constants';

function capitalizeFirstLetter(s = '') {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// NOTE: only supporting currencies that divide into 100 basic units
function priceFromInput(value) {
  const priceMatcher = /^\d*\.?\d{0,2}/;

  return priceMatcher.exec(value)[0];
}

function displayPriceSubUnit(priceSubUnit) {
  if (isNaN(priceSubUnit)) {
    return '0.00';
  }

  return (priceSubUnit / 100).toFixed(2);
}

function displayChoiceLimitHeader(limit) {
  return limit === 0 ? `Limit: ${CHOICE_LIMIT_ZERO}` : `Limit: ${limit}`;
}

function displayChoiceLimit(limit) {
  return limit === 0 ? CHOICE_LIMIT_ZERO : `Limit: ${limit}`;
}

function toSubUnit(num) {
  return Math.round(num * 100);
}

function checkHttpError(response) {
  if (response.statusCode >= 400) {
    // If the response status code is an error, but there's not
    // error message set, return a generic error
    if (!response || !response.data || !response.data.description) {
      throw new Error('Undefined API error');
    }

    return true;
  }

  return false;
}

function populateItemID(item) {
  let { id } = item;

  if (!id || id.length === 0) {
    id = uuidv4();
  }

  return { ...item, id };
}

export {
  capitalizeFirstLetter,
  priceFromInput,
  displayPriceSubUnit,
  displayChoiceLimit,
  displayChoiceLimitHeader,
  toSubUnit,
  checkHttpError,
  populateItemID,
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/utils/index.js